import {Component, Input, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {DeviceParamLirisV3} from "../../../../../../shared/classes/device/type-v3/device-param-liris-v3";
import {ToastrService} from "ngx-toastr";
import {TranslateService} from "@ngx-translate/core";

@Component({
    selector: 'app-param-channels-expe',
    templateUrl: './param-channels-expe.component.html',
    styleUrls: ['./param-channels-expe.component.css']
})
export class ParamChannelsExpeComponent implements OnInit {


    channelsForm: FormGroup;
    @Input('deviceParamLirisV3') deviceParamLirisV3: DeviceParamLirisV3;
    @Input('editable') editable: boolean = true;

    constructor(private toastr: ToastrService,
                private translate: TranslateService) {
    }

    ngOnInit() {
        this.channelsForm = new FormGroup({
            expeChannels: new FormControl(this.deviceParamLirisV3.inclinoAxes),
        });
    }

    setChannelsForm() {
        this.deviceParamLirisV3.inclinoAxes = this.channelsForm.value.expeChannels;
        this.toastr.warning('You changed the channel setting ! Be careful of the channel setting of this sensors', this.translate.instant('WARNING'));
    }

}
